<template>
  <div class="home-container" :class="this.$store.state.isMobile ? 'isMobile' : ''">
    <!-- 手机端吸顶   -->
    <div class="mobeil-menu-top" v-if="mobeilMenuShow " >
      <img src="../assets/images/logo.png" alt="" class="logo">
      <div class="right-icon">
        <img
            class="header-user-img"
            src="../assets/images/user.png"
            @click="toLogin"
        />
        <span class="line">|</span>
        <img
            class="header-toggle-img"
            src="../assets/images/collapse.png"
            @click="changenavbarOpen"
        />
      </div>
    </div>

    <!-- pc端吸顶   -->
    <div class="pc-menu-top" v-if="pcMenuShow && !this.$store.state.isMobile" >
     <ul>
       <li v-for="(item,index) in menuList"
           :class="{ active: pcTabIndex == index }"
           @click="menuClick_tab(item.type, index, item.name)"
       >{{item.name}}</li>
     </ul>
    </div>

    <div class="banner-con page-box" id="matchHome" v-if="this.$route.name == 'home'">
      <div class="home-center">
        <div class="banner-t25">
        </div>
        <Header :mobeilMenuShow = "mobeilMenuShow" :pcMenuShow = "pcMenuShow"  ref="headerCom" @getTabIndex="changeTabIndex" />
        <div class="video-banner">
          <video v-if="!isShowWapBanner" playsinline autoplay muted loop src="https://dellvideo.smarket.net.cn/c79228fca93d4420b5a8f4d5bfbdf338/103aa8dbb2764e87b89134c183f35fe8-b7d2f470dabcde83d0d4ff3769ac3a2b-od-S00000001-200000.mp4#t=0.1">
          </video>
          <video id="videoBanner" v-else playsinline autoplay muted loop src="https://dellvideo.smarket.net.cn/4113d4be35d0436ba912d5f140432637/1cd9f57a4a4542e9971251dc9b467202-acc668dfb14cc627cd80002c4f58362a-od-S00000001-200000.mp4#t=0.1" poster="https://dellvideo.smarket.net.cn/4113d4be35d0436ba912d5f140432637/snapshots/97c3f29b61144435bfb4b93b86ac6744-00001.jpg" width="100%">
          </video>

          <div class="video-mask"></div>
        </div>
        <BannerText/>
      </div>
    </div>
    <div v-show="this.$route.name == 'home'">
      <AllWorks class="page-box" ></AllWorks>
      <AwardSetting/>
      <Judges/>
      <EntryInformation class="page-box"></EntryInformation>
    </div>

  <!-- 其他子页面-->
    <div class="home-bg-top" v-if="this.$route.name != 'home'"></div>
    <Header :mobeilMenuShow = "mobeilMenuShow"
            :pcMenuShow = "pcMenuShow"
            v-if="this.$route.name != 'home'"
            ref="headerCom"
            @getTabIndex="changeTabIndex" />
    <router-view/>

  <!-- 公共-->
    <EndMsgDialog :show="endMsgDialog" @close="endMsgDialog = false"></EndMsgDialog>
    <Footer/>
    <div class="toTop" v-show="toTopShow" @click="changetoTop">
      <i class="el-icon-upload2"></i>
      <p>顶部</p>
    </div>
    <!--<EmailSendFile></EmailSendFile>-->
  </div>
</template>

<script>
import EndMsgDialog from '@/components/EndMsgDialog';
import Header from '@/components/Header.vue';
import BannerText from '@/components/BannerText';
import EntryInformation from '@/components/EntryInformation';
import AllWorks from '@/components/AllWorks';
import AwardSetting from '@/components/AwardSetting';
import Judges from '@/components/Judges';
import Footer from '@/components/Footer';
// import EmailSendFile from '@/components/EmailSendFile';
import _ from "lodash";
import {mapState} from "vuex";
export default {
  name: 'Home',
  components: {
    EndMsgDialog,
    Header,
    BannerText,
    AllWorks,
    EntryInformation,
    AwardSetting,
    Judges,
    Footer,
    // EmailSendFile
  },
  data(){
    return{
      endMsgDialog: true,
      toTopShow: false,
      isShowWapBanner: false,
        // 页面级变量
        pageRecord:{
            title:'precision25周年',
            module: 'precision25周年',
            category1: '首页',
        },
      mobeilMenuShow: false,
      pcMenuShow: false,
      menuList: [
        {type: 'matchHome', name: '首页',},
        {type: 'eventArrangement', name: '赛事安排',},
        {type: 'entryInformation', name: '参赛须知',},
        {type: 'winList', name: '中奖名单',},
        {type: 'allWorks', name: '全部作品',},
        {type: 'dellPrecision', name: 'DELL Precision 25周年',}
      ],
      pcTabIndex: 0,
    }
  },
  computed: mapState(['toTabClick']),
  mounted() {
    //每次登录成功后就判断是否上传过  把用户userWorkId存储起来
    if(this.$tool.isLogin()){
      this.getMyWorkId()
    }
    // 监听滚动事件
    window.addEventListener(
        "scroll",
        _.debounce(
            () => {
              // if(this.pcTabIndex == 4 || this.pcTabIndex == 5){
              //   this.pcTabIndex = 0
              // }
              //header 滚动 超过 100px header背景颜色 变深
              this.scrollTop = document.documentElement.scrollTop
              let scrollTop =
                  document.documentElement.scrollTop || document.body.scrollTop;
              if(scrollTop > document.documentElement.clientHeight){
                this.toTopShow = true
              }else{
                this.toTopShow = false
              }
              if(scrollTop > 90 && (this.$store.state.isMobile || document.documentElement.clientWidth <= 992) ){
                this.mobeilMenuShow = true;
              }if(scrollTop <= 90 && (this.$store.state.isMobile || document.documentElement.clientWidth >992)){
                this.mobeilMenuShow = false;
              }if(scrollTop >= 120 && !this.$store.state.isMobile){
                if(this.$route.name == 'opusReveal'){
                  this.pcTabIndex = 4;
                }
                if(this.$route.name == 'winnersList'){
                  this.pcTabIndex = 3;
                }
                this.pcMenuShow = true;
              }if(scrollTop < 120 && !this.$store.state.isMobile){
                this.pcMenuShow =false;
              }
            },
            false
        ),
        true
    );

    window.onresize = setBanner;

    let that = this;
    function setBanner() {
      let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      width >= 992?that.isShowWapBanner = false:that.isShowWapBanner = true;
    }
    setBanner()


    // 播放视频banner
    function audioAutoPlay(id){
      play();
      document.addEventListener("WeixinJSBridgeReady", function () {
        play();
      }, false);
      document.addEventListener('YixinJSBridgeReady', function() {
        play();
      }, false);

      function play() {
        let video = document.getElementById(id);
        if(!video){
          return
        }
        video.setAttribute('playsinline', 'true');
        video.setAttribute('autoplay', 'true');
        video.setAttribute('preload', 'auto');
        video.setAttribute('webkit-playsInline', 'true');
        video.setAttribute('x-webkit-airplay', 'allow');
        video.setAttribute('x5-video-player-type', 'h5');
        video.setAttribute('x5-video-player-fullscreen', 'true');
        video.setAttribute('x5-video-orientation', 'portraint');
        video.play();
        video = null;
      }
    }
    audioAutoPlay('videoBanner');

    // 解决微信端切后台后视频暂停播放的问题
    setInterval(function () {
      audioAutoPlay('videoBanner');
    },1000)
  },
  watch: {
    toTabClick(newVal, old) {
     if(newVal){
       if(newVal ){
         this.$nextTick(()=>{
           this.menuList.forEach((item, index)=>{
             if(newVal == item.type){
               this.menuClick_tab(item.type, index, item.name);
             }
           })
         })
       }
     }
    }
  },
  methods: {
    changetoTop() {
      document.documentElement.scrollTop = 0
    },
    changenavbarOpen() {
      this.$emit('toChangeNavbarOpen')
      this.$refs.headerCom.changeNavbarOpen();
    },
    menuClick_tab(type, idx, ch) {
      this.pcTabIndex = idx
      if(type == 'allWorks') {
        this.$router.push({path: '/opusReveal'});
      }
      else if(type == "winList"){
          this.$router.push({path:'/winnersList'});
      }else{
        this.$refs.headerCom.didClick_tab(type, idx, ch);
      }
    },
    changeTabIndex(val) {
      this.pcTabIndex = val
    },
    toLogin() {
      this.$refs.headerCom.toLoginCom('登录', 0,);
    },
    getMyWorkId(data) {
      this.$api.getMyWork(this.$tool.isLogin().session, this.$tool.isLogin().OCSESSID)
          .then(res=>{
            //未上传作品
            if(res.data.work_id){
              //改变workId
              this.$tool.setLS('workId', res.data.work_id,1)
              //登录这者 workId 用来判断审核状态的显隐
              this.$tool.setLS('userWorkId', res.data.work_id,1)
            }else{
            }
          })
          .catch((e) => {
          });
    },
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/home";
</style>
